// src/features/executive/performance/drill/KeyProceduresDrill.tsx
import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useKeyProceduresDetail } from '../hooks/use-key-procedures-detail'
import DrillTable from 'features/executive/components/DrillTable/DrillTable'
import type { ExecutiveState } from 'app/slice/executive.slice'
import { formatCurrency, formatDateThaiShort } from 'utils/executive.utils'
import { useRegisterDrillExport } from 'features/executive/components/DrillDrawer/DrillExportContext'

export default function KeyProceduresDrill() {
  const { t } = useTranslation()
  const stack = useSelector((s: { executive: ExecutiveState }) => s.executive.drillStack)
  const top = stack[stack.length - 1]
  const { data, loading, error, refetch } = useKeyProceduresDetail(top?.scopedFilters)

  const widgetTitle = top?.label ?? t('EXECUTIVE.PERFORMANCE.KEY_PROCEDURES.TITLE')
  useRegisterDrillExport(
    data ? { drillId: 'key-procedures', data: data.rows } : null,
    'performance.key-procedures-detail',
    widgetTitle
  )

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {top?.label ?? t('EXECUTIVE.PERFORMANCE.KEY_PROCEDURES.TITLE')}
      </Typography>
      <DrillTable
        rows={data?.rows ?? []}
        columns={[
          { key: 'procedure', label: t('EXECUTIVE.PERFORMANCE.KEY_PROCEDURES.PROCEDURE'), render: (r) => r.procedure.name },
          { key: 'date', label: t('EXECUTIVE.DRILL.DATE', 'Date'), render: (r) => formatDateThaiShort(r.date) },
          { key: 'cases', label: t('EXECUTIVE.PERFORMANCE.KEY_PROCEDURES.CASES'), align: 'right', render: (r) => r.cases },
          { key: 'revenue', label: t('EXECUTIVE.PERFORMANCE.KEY_PROCEDURES.REVENUE'), align: 'right', render: (r) => formatCurrency(r.revenue) },
        ]}
        loading={loading}
        error={error}
        onRetry={refetch}
      />
    </Box>
  )
}
